(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5781],{

/***/ 4263:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/empresa/[empresa]",
      function () {
        return __webpack_require__(8809);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 638:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _instanceof = (__webpack_require__(6856)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7294));
var _loadable = _interop_require_default(__webpack_require__(4302));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if ( true && loadableOptions.suspense) {
        throw new Error("Invalid suspense option usage in next/dynamic. Read more: https://nextjs.org/docs/messages/invalid-dynamic-suspense");
    }
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
"client";
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 6319:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7294));
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 4302:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(9658)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(7222)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7294));
var _loadableContext = __webpack_require__(6319);
var useSyncExternalStore = ( false ? 0 : __webpack_require__(1688)).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            this._delay = setTimeout(function() {
                                _this._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        this._timeout = setTimeout(function() {
                            _this._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _extends({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 7517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Breadcrumb; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/hub.js + 9 modules
var hub = __webpack_require__(5877);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./src/components/Layout/Breadcrumb/styles.tsx




var BreadcrumbItemContainer = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "flex flex-row items-center font-light text-mglGray500 before:mr-2 before:flex before:h-[13px] before:w-2 before:items-center before:justify-center before:pb-[3px] before:text-center before:text-base before:leading-none before:content-['›'] first-of-type:before:content-none"
    }, props), {
        children: props.children
    }));
};
var BreadcrumbItem = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "flex h-4 flex-row items-center text-xs leading-4 text-mglGray500 no-underline"
    }, props), {
        ref: ref,
        children: props.children
    }));
});


// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
;// CONCATENATED MODULE: ./src/components/Layout/Breadcrumb/index.tsx
/* eslint-disable react/no-array-index-key */ 





var publicRuntimeConfig = config_default()().publicRuntimeConfig;
function Breadcrumb(param) {
    var breadcrumbList = param.breadcrumbList, _isSubDomain = param.isSubDomain, isSubDomain = _isSubDomain === void 0 ? false : _isSubDomain;
    var ref;
    var currentSpan = (ref = (0,hub/* getCurrentHub */.Gd)().getScope()) === null || ref === void 0 ? void 0 : ref.getSpan();
    var breadcrumbSpan = currentSpan && currentSpan.startChild({
        op: "breadcrumb"
    });
    var workingList = (0,_to_consumable_array/* default */.Z)(breadcrumbList).filter(function(item) {
        return item.url !== "/";
    });
    workingList.unshift({
        titulo: "Home",
        url: "/"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "place-content-[center_start] mb-2 flex flex-wrap items-center gap-2",
        children: [
            workingList.map(function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadcrumbItemContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: isSubDomain ? "".concat(publicRuntimeConfig.NEXT_PUBLIC_URL).concat(item.url) : item.url,
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadcrumbItem, {
                            title: "Ir para ".concat(item.titulo),
                            children: item.titulo
                        })
                    })
                }, item.url);
            }),
            breadcrumbSpan && breadcrumbSpan.finish()
        ]
    });
}


/***/ }),

/***/ 1080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9659);


function Container(param) {
    var children = param.children, _hasBreadcrumb = param.hasBreadcrumb, hasBreadcrumb = _hasBreadcrumb === void 0 ? false : _hasBreadcrumb, _className = param.className, className = _className === void 0 ? "" : _className;
    var variants = {
        hasBreadcrumb: {
            true: "mt-4 desktop:mt-10",
            false: ""
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("w-full max-w-[calc(100%-2rem)] desktop:max-w-[83.33%]", variants.hasBreadcrumb[hasBreadcrumb.toString()], className),
        children: children
    });
}


/***/ }),

/***/ 3078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WrapperContent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1080);
/* harmony import */ var _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9642);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9659);




function WrapperContent(param) {
    var children = param.children, backgroundColor = param.backgroundColor, _isOnHeader = param.isOnHeader, isOnHeader = _isOnHeader === void 0 ? false : _isOnHeader, _paddingOnBottom = param.paddingOnBottom, paddingOnBottom = _paddingOnBottom === void 0 ? false : _paddingOnBottom, _paddingOnTop = param.paddingOnTop, paddingOnTop = _paddingOnTop === void 0 ? false : _paddingOnTop, _hasBreadcrumb = param.hasBreadcrumb, hasBreadcrumb = _hasBreadcrumb === void 0 ? false : _hasBreadcrumb, _mobileOnly = param.mobileOnly, mobileOnly = _mobileOnly === void 0 ? false : _mobileOnly, _desktopOnly = param.desktopOnly, desktopOnly = _desktopOnly === void 0 ? false : _desktopOnly, _className = param.className, className = _className === void 0 ? undefined : _className;
    var variants = {
        isOnHeader: {
            true: "isOnHeader [&.isOnHeader]:p-0",
            false: ""
        },
        paddingOnBottom: {
            true: "paddingOnBottom [&.paddingOnBottom]:pb-10",
            false: "pb-0"
        },
        paddingOnTop: {
            true: "paddingOnTop [&.paddingOnTop]:pt-10",
            false: ""
        },
        mobileOnly: {
            true: "flex desktop:hidden",
            false: ""
        },
        desktopOnly: {
            true: "hidden desktop:flex",
            false: ""
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        style: {
            backgroundColor: backgroundColor || _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_2__/* .mglGray.mglGray50 */ .Ce.mglGray50
        },
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("relative flex w-full flex-col flex-wrap content-center justify-center px-0 py-10", variants.isOnHeader[isOnHeader.toString()], variants.paddingOnBottom[paddingOnBottom.toString()], variants.paddingOnTop[paddingOnTop.toString()], variants.mobileOnly[mobileOnly.toString()], variants.desktopOnly[desktopOnly.toString()]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Container__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            hasBreadcrumb: hasBreadcrumb,
            className: className,
            children: children
        })
    });
}


/***/ }),

/***/ 1530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ProfileLinks; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_Layout_Icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6008);
/* harmony import */ var _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9642);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9659);




function ProfileLinks(param) {
    var links = param.links, type = param.type;
    var profileIcons = {
        website: "mdi:earth",
        facebook: "mdi:facebook",
        twitter: "mdi:twitter",
        instagram: "mdi:instagram",
        youtube: "mdi:youtube",
        linkedin: "mdi:linkedin"
    };
    var variants = {
        hasGrayBackground: {
            true: {
                background: "bg-mglGray100 ",
                hover: "group-focus:text-mglGray500 group-hover:text-mglGray500"
            },
            false: {
                background: "bg-mglBlue50 ",
                hover: "group-focus:text-mglBlue200 group-hover:text-mglBlue200"
            }
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
        className: "flex flex-wrap justify-center gap-2",
        children: Object.entries(links).map(function(link) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("flex h-8 w-8 items-center justify-center rounded-half bg-mglBlue50 transition-colors duration-300 ease-ease [&>a>svg>path]:transition-colors [&>a>svg>path]:duration-300 [&>a>svg>path]:ease-ease focus:[&>a>svg>path]:text-mglGray500 [&>a]:flex", variants.hasGrayBackground[(type !== "autor").toString()].background),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    target: "_blank",
                    href: link[1],
                    rel: "noreferrer",
                    title: "".concat(link[0].charAt(0).toUpperCase() + link[0].slice(1)),
                    className: "group",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_Icon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        width: 24,
                        height: 24,
                        color: type === "autor" ? _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_2__/* .mglBlue.mglBlue400 */ .Db.mglBlue400 : _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_2__/* .mglGray.mglGray700 */ .Ce.mglGray700,
                        icon: profileIcons[link[0]],
                        className: variants.hasGrayBackground[(type !== "autor").toString()].hover
                    })
                })
            }, link[0]);
        })
    });
}


/***/ }),

/***/ 4621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hy": function() { return /* binding */ ProfileHeaderContainer; },
/* harmony export */   "wM": function() { return /* binding */ ProfileHeaderCover; },
/* harmony export */   "zE": function() { return /* binding */ ProfileHeaderTitle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9659);


var ProfileHeaderContainer = function(param) {
    var children = param.children, _round = param.round, round = _round === void 0 ? false : _round;
    var variants = {
        round: {
            true: "[&>figure]:rounded-half [&>figure>img]:rounded-half",
            false: "[&>figure]:rounded-lg"
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("header", {
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("mb-6 mt-[-120px] flex flex-col items-center gap-4 pt-6 tablet:mb-0 [&>figure]:inline-block [&>figure]:h-[120px] [&>figure]:w-[120px] [&>figure]:border-4 [&>figure]:border-solid [&>figure]:border-mglGray50 [&>figure]:bg-gray-50 [&>figure]:shadow-mdc-elevation-z3-2", variants.round[round.toString()]),
        children: children
    });
};
var ProfileHeaderTitle = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
        className: "text-center text-[1.75rem] text-mglGray900",
        children: children
    });
};
var ProfileHeaderCover = function(param) {
    var _blueBackground = param.blueBackground, blueBackground = _blueBackground === void 0 ? false : _blueBackground;
    var variants = {
        blueBackground: {
            true: "bg-mglBlue400",
            false: "bg-mglGray700"
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("h-[120px] w-full rounded-lg", variants.blueBackground[blueBackground.toString()])
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({});


/***/ }),

/***/ 1379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ProfilePage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/components/Profile/ProfileBio/index.tsx

function ProfileBio(param) {
    var title = param.title, content = param.content;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "text-sm font-medium",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: content
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/Internals/ContentComposer/index.tsx + 1 modules
var ContentComposer = __webpack_require__(944);
// EXTERNAL MODULE: ./src/components/Profile/ProfileHeader/ProfileLinks/index.tsx
var ProfileLinks = __webpack_require__(1530);
// EXTERNAL MODULE: ./src/components/Profile/ProfileHeader/styles.tsx
var styles = __webpack_require__(4621);
// EXTERNAL MODULE: ./src/components/Ads/Google/AdsTypeGeneratorsMemo/index.tsx
var AdsTypeGeneratorsMemo = __webpack_require__(9831);
// EXTERNAL MODULE: ./src/components/Internals/HeaderImage/Image/index.tsx + 1 modules
var Image = __webpack_require__(4486);
;// CONCATENATED MODULE: ./src/components/Profile/index.tsx







var formatDate = function(date) {
    return date.length > 4 ? new Intl.DateTimeFormat("pt-Br", {
        timeZone: "UTC",
        dateStyle: "long"
    }).format(new Date(date)) : new Intl.DateTimeFormat("pt-Br", {
        timeZone: "UTC",
        year: "numeric"
    }).format(new Date(date));
};
var formatSpaceTime = function(param) {
    var date = param.date, place = param.place;
    if (date && place) return "".concat(formatDate(date), " em ").concat(place);
    if (date) return formatDate(date);
    if (place) return place;
    return "";
};
function ProfilePage(param) {
    var nome = param.nome, imagem = param.imagem, links = param.links, codigoBolsa = param.codigoBolsa, subsidiariaDe = param.subsidiariaDe, fundacao = param.fundacao, nascimento = param.nascimento, morte = param.morte, texto = param.texto, type = param.type;
    var hasBirth = nascimento && (nascimento.data || nascimento.local);
    var hasDeath = morte && (morte.data || morte.local);
    var hasFoundation = fundacao && (fundacao.data || fundacao.local);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ProfileHeaderCover */.wM, {
                blueBackground: type === "autor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mx-auto mb-6 mt-0 flex max-w-full flex-col gap-6 tablet:max-w-[calc(100%-336px-32px)] [&_#content-news>div:first-of-type]:float-none [&_#content-news>div:first-of-type]:mx-auto [&_#content-news>div:first-of-type]:mb-6 [&_#content-news>div:first-of-type]:mt-0 largeDesktop:[&_#content-news>div:first-of-type]:float-right largeDesktop:[&_#content-news>div:first-of-type]:mb-0 largeDesktop:[&_#content-news>div:first-of-type]:ml-6 [&_#content-news]:block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ProfileHeaderContainer */.Hy, {
                        round: type !== "empresa",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: imagem.url,
                                width: 120,
                                height: 120,
                                alt: nome
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ProfileHeaderTitle */.zE, {
                                children: nome
                            }),
                            links && Object.values(links).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileLinks/* default */.Z, {
                                links: links,
                                type: type
                            })
                        ]
                    }),
                    (hasBirth || hasDeath || hasFoundation || codigoBolsa || subsidiariaDe) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "flex flex-col gap-4 rounded-lg border border-solid border-mglGray200 p-4 font-light text-mglGray900",
                        children: [
                            nascimento && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileBio, {
                                title: "Nascimento",
                                content: formatSpaceTime({
                                    date: nascimento.data,
                                    place: nascimento.local
                                })
                            }),
                            morte && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileBio, {
                                title: "Morte",
                                content: formatSpaceTime({
                                    date: morte.data,
                                    place: morte.local
                                })
                            }),
                            fundacao && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileBio, {
                                title: "Funda\xe7\xe3o",
                                content: formatSpaceTime({
                                    date: fundacao.data,
                                    place: fundacao.local
                                })
                            }),
                            codigoBolsa && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileBio, {
                                title: "C\xf3digo da Bolsa",
                                content: codigoBolsa
                            }),
                            subsidiariaDe && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileBio, {
                                title: "Subsidi\xe1ria de",
                                content: subsidiariaDe
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        id: "content-news",
                        children: [
                            type !== "autor" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    width: "336px",
                                    height: "300px",
                                    backgroundColor: "rgba(0, 0, 0, 0.06)"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdsTypeGeneratorsMemo["default"], {
                                    type: "rectangle/main/internal",
                                    marginBottomP: "24px"
                                })
                            }),
                            texto && (typeof texto === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: texto
                            }) : texto.map(function(element, index) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(ContentComposer/* default */.Z, {
                                    tipo: element.tipo,
                                    as: element.tag,
                                    url: element.url,
                                    target: element.target,
                                    valor: element === null || element === void 0 ? void 0 : element.valor,
                                    atributos: element === null || element === void 0 ? void 0 : element.atributos
                                }, "".concat(element.tipo, "-").concat(index));
                            }))
                        ]
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 9729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ ProfileAdContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var ProfileAdContainer = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex h-[300px] justify-center bg-mglGray50 pt-6 tablet:h-[250px] tablet:pt-0",
        children: children
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({});


/***/ }),

/***/ 804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

var PageDataContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
/* harmony default export */ __webpack_exports__["Z"] = (PageDataContext);


/***/ }),

/***/ 8809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ CompanyProfile; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7590);
/* harmony import */ var _components_Layout_Breadcrumb__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7517);
/* harmony import */ var _components_Layout_WrapperContent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3078);
/* harmony import */ var _components_Profile__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1379);
/* harmony import */ var _components_Profile_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9729);
/* harmony import */ var _hooks_useBreakpoint__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2140);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_8__);










var FeaturedLastNews = next_dynamic__WEBPACK_IMPORTED_MODULE_7___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2826), __webpack_require__.e(6611)]).then(__webpack_require__.bind(__webpack_require__, 2826));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2826)
            ];
        }
    },
    ssr: false
});
var FeaturedProducts = next_dynamic__WEBPACK_IMPORTED_MODULE_7___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3213), __webpack_require__.e(7637), __webpack_require__.e(2909)]).then(__webpack_require__.bind(__webpack_require__, 2909));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2909)
            ];
        }
    },
    ssr: false
});
var AdsGeneratorMemo = next_dynamic__WEBPACK_IMPORTED_MODULE_7___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 9831));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9831)
            ];
        }
    },
    ssr: false
});
var __N_SSP = true;
function CompanyProfile(param) {
    var responseData = param.responseData, navBarData = param.navBarData, _timelineData = param.timelineData, timelineData = _timelineData === void 0 ? null : _timelineData;
    var ref;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_8__.useRouter)();
    var empresa = router.query.empresa;
    var data = responseData.data, segmentacoes = responseData.segmentacoes, schema = responseData.schema, ssr = responseData.ssr, breadcrumb = responseData.breadcrumb;
    var nome = data.nome, fundacao = data.fundacao, codigoBolsa = data.codigoBolsa, subsidiariaDe = data.subsidiariaDe, imagem = data.imagem, links = data.links, texto = data.texto, produtosEmpresa = data.produtosEmpresa;
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_hooks_useBreakpoint__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("tablet"), 1), isMobile = ref1[0];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Layout__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        layoutData: {
            navBarData: navBarData,
            segmentacoes: segmentacoes,
            tagsData: ssr,
            schema: schema,
            breadcrumbList: breadcrumb
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Layout_WrapperContent__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                isOnHeader: true,
                hasBreadcrumb: true,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_Breadcrumb__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        breadcrumbList: breadcrumb
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Profile__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        nome: nome,
                        imagem: imagem,
                        links: links,
                        codigoBolsa: codigoBolsa,
                        subsidiariaDe: subsidiariaDe,
                        fundacao: fundacao,
                        texto: texto,
                        produtosEmpresa: produtosEmpresa,
                        type: "empresa"
                    })
                ]
            }),
            produtosEmpresa && produtosEmpresa.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FeaturedProducts, {
                featuredProductsData: produtosEmpresa,
                title: "Produtos ".concat(nome),
                shouldShowChip: true,
                url: "/empresa/".concat(empresa, "/produtos/")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Profile_styles__WEBPACK_IMPORTED_MODULE_5__/* .ProfileAdContainer */ .g, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AdsGeneratorMemo, {
                    type: "".concat(isMobile ? "rectangle" : "billboard", "/main/listing"),
                    marginBottomP: "24px"
                })
            }),
            timelineData && (timelineData === null || timelineData === void 0 ? void 0 : (ref = timelineData.data) === null || ref === void 0 ? void 0 : ref.timeline) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FeaturedLastNews, {
                featuredLastNewsData: timelineData.data.timeline,
                rootPage: "empresa/".concat(empresa),
                textTitle: "\xdaltimas sobre ".concat(nome),
                route: empresa,
                routeType: "empresa"
            })
        ]
    });
}


/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(638)


/***/ }),

/***/ 3250:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e=__webpack_require__(7294);function h(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var k="function"===typeof Object.is?Object.is:h,l=e.useState,m=e.useEffect,n=e.useLayoutEffect,p=e.useDebugValue;function q(a,b){var d=b(),f=l({inst:{value:d,getSnapshot:b}}),c=f[0].inst,g=f[1];n(function(){c.value=d;c.getSnapshot=b;r(c)&&g({inst:c})},[a,d,b]);m(function(){r(c)&&g({inst:c});return a(function(){r(c)&&g({inst:c})})},[a]);p(d);return d}
function r(a){var b=a.getSnapshot;a=a.value;try{var d=b();return!k(a,d)}catch(f){return!0}}function t(a,b){return b()}var u="undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement?t:q;exports.useSyncExternalStore=void 0!==e.useSyncExternalStore?e.useSyncExternalStore:u;


/***/ }),

/***/ 1688:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(3250);
} else {}


/***/ }),

/***/ 2222:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [162,1216,8912,8802,7590,944,9774,2888,179], function() { return __webpack_exec__(4263); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);